










import Vue from 'vue';

import { SkupinaProfilSelect } from '../../components';
import ProvozovnaSelect from '../../components/microcomponents/ProvozovnaSelect.vue';
import SlevaMaterialNumberInput from '../../components/microcomponents/SlevaMaterialNumberInput.vue';

export default Vue.extend({
	name: 'HlavniKarta',
	components: {
		SlevaMaterialNumberInput,
		ProvozovnaSelect,
		SkupinaProfilSelect,
	},
	props: {
		storeUri: {
			type: String,
			required: true,
		},
	},
});
